'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _dec2, _class2, _dec3, _class3, _dec4, _class4, _dec5, _class5, _dec6, _dec7, _class6, _class7, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactLoader = require('react-loader');

var _reactLoader2 = _interopRequireDefault(_reactLoader);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _convert = require('../../helpers/convert');

var _convert2 = _interopRequireDefault(_convert);

var _analytics = require('../../helpers/analytics');

var _analytics2 = _interopRequireDefault(_analytics);

var _components = require('../../components');

var _search = require('redux/modules/search');

var searchActions = _interopRequireWildcard(_search);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Styles = require('./Family.css');

/**
 * <FamilyBanner
 *   fundFamily
 * />
 * 
 * Displays a banner for the fund family that has a different tagline if the
 * family is one of the 10 families with additional data in config, or just
 * a generic fund family.
 * 
 */
var FamilyBanner = (_dec = (0, _reactCssModules2.default)(Styles, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(FamilyBanner, _Component);

  function FamilyBanner(props) {
    (0, _classCallCheck3.default)(this, FamilyBanner);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FamilyBanner.__proto__ || (0, _getPrototypeOf2.default)(FamilyBanner)).call(this, props));

    _this.state = {
      fundFamily: props.fundFamily || null
    };
    return _this;
  }

  (0, _createClass3.default)(FamilyBanner, [{
    key: 'render',
    value: function render() {
      var fundFamily = this.state.fundFamily;

      if (!fundFamily) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { styleName: 'banner-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'banner' },
          _react2.default.createElement(
            'div',
            { styleName: 'banner-inner' },
            _react2.default.createElement(
              'div',
              { styleName: 'banner-taglines' },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { styleName: 'banner-tagline' },
                  fundFamily ? _react2.default.createElement(
                    'span',
                    null,
                    'Are your retirement funds'
                  ) : _react2.default.createElement(
                    'span',
                    null,
                    'Your retirement plan could'
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { styleName: 'banner-tagline' },
                  fundFamily ? _react2.default.createElement(
                    'span',
                    null,
                    'invested with ',
                    fundFamily.fund_family_label,
                    '?'
                  ) : _react2.default.createElement(
                    'span',
                    null,
                    'be funding deforestation'
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'toolkit' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'toolkit-info' },
                  'Check out our action toolkit and talk to your retirement plan manager'
                ),
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: _config2.default.routes.toolkit,
                    log: _analytics2.default.eventToToolkit(),
                    title: '#Defund deforestation action toolkit' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'toolkit-action' },
                    'Action toolkit',
                    _react2.default.createElement(_components.LinkIcon, null)
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return FamilyBanner;
}(_react.Component)) || _class);

/**
 * <FamilySummarySentence
 *   fundFamily
 * />
 *
 * Displays sentence for the fund family that names the fund company
 * at the top of the list of funds and shareclasses for this family.
 *
 */

var FamilySummarySentence = (_dec2 = (0, _reactCssModules2.default)(Styles, { allowMultiple: true }), _dec2(_class2 = function (_Component2) {
  (0, _inherits3.default)(FamilySummarySentence, _Component2);

  function FamilySummarySentence(props) {
    (0, _classCallCheck3.default)(this, FamilySummarySentence);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (FamilySummarySentence.__proto__ || (0, _getPrototypeOf2.default)(FamilySummarySentence)).call(this, props));

    _this2.state = {
      fundFamily: props.fundFamily || null
    };
    return _this2;
  }

  (0, _createClass3.default)(FamilySummarySentence, [{
    key: 'render',
    value: function render() {
      var fundFamily = this.state.fundFamily;

      if (!fundFamily) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { styleName: 'summary' },
        fundFamily.fund_family_label,
        ' funds in our database'
      );
    }
  }]);
  return FamilySummarySentence;
}(_react.Component)) || _class2);

/**
 * <FamilyFundList
 *   fundList
 * />
 * 
 * Displays a list of funds for this family. Maps a fundList to a list of
 * FamilyFundListItem components.
 * 
 */

var FamilyFundList = (_dec3 = (0, _reactCssModules2.default)(Styles, { allowMultiple: true }), _dec3(_class3 = function (_Component3) {
  (0, _inherits3.default)(FamilyFundList, _Component3);

  function FamilyFundList(props) {
    (0, _classCallCheck3.default)(this, FamilyFundList);

    var _this3 = (0, _possibleConstructorReturn3.default)(this, (FamilyFundList.__proto__ || (0, _getPrototypeOf2.default)(FamilyFundList)).call(this, props));

    _this3.state = {
      fundList: props.fundList || null
    };
    return _this3;
  }

  (0, _createClass3.default)(FamilyFundList, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      if (props.fundList) {
        this.setState({
          fundList: props.fundList
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var fundList = this.state.fundList;

      if (!fundList) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { styleName: 'holding-list' },
        fundList.map(function (fund, idx) {
          return _react2.default.createElement(FamilyFundListItem, {
            fund: fund,
            key: 'family-fund-list-item-' + idx
          });
        })
      );
    }
  }]);
  return FamilyFundList;
}(_react.Component)) || _class3);

/**
 * <FamilyFundListItem 
 *   fund
 * />
 * 
 * Displays a fund in the list of funds for this family. Displays some summary
 * stats. Displays a list of tickers using the FamilyFundListItemTickerLinks
 * component.
 * 
 */

var FamilyFundListItem = (_dec4 = (0, _reactCssModules2.default)(Styles, { allowMultiple: true }), _dec4(_class4 = function (_Component4) {
  (0, _inherits3.default)(FamilyFundListItem, _Component4);

  function FamilyFundListItem(props) {
    (0, _classCallCheck3.default)(this, FamilyFundListItem);

    var _this4 = (0, _possibleConstructorReturn3.default)(this, (FamilyFundListItem.__proto__ || (0, _getPrototypeOf2.default)(FamilyFundListItem)).call(this, props));

    _this4.state = {
      fund: props.fund || null
    };
    return _this4;
  }

  (0, _createClass3.default)(FamilyFundListItem, [{
    key: 'render',
    value: function render() {
      var fund = this.state.fund;

      if (!fund) {
        return null;
      }

      var fund_id = fund.fund_id,
          fund_legal_name = fund.fund_legal_name,
          currency = fund.currency,
          po_all_count = fund.po_all_count,
          po_all_asset = fund.po_all_asset,
          po_all_weight = fund.po_all_weight,
          grade_deforestation = fund.grade_deforestation;


      return _react2.default.createElement(
        'div',
        { styleName: 'holding' },
        _react2.default.createElement(
          'div',
          { styleName: 'ticker-name-assets' },
          _react2.default.createElement(
            'div',
            { styleName: 'ticker-name' },
            _react2.default.createElement(
              'div',
              { styleName: 'holdings-name' },
              fund_legal_name
            ),
            _react2.default.createElement(FamilyFundListItemTickerLinks, { shareclasses: fund.shareclass })
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'ticker-assets' },
            _react2.default.createElement(
              'div',
              { styleName: 'ticker-assets-figure' },
              _format2.default.number(po_all_count)
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'ticker-assets-label' },
              '\xA0deforestation-risk stocks'
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'ticker-assets' },
            _react2.default.createElement(
              'div',
              { styleName: 'ticker-assets-figure' },
              _format2.default.money(po_all_asset, true, currency, true)
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'ticker-assets-label' },
              '\xA0invested'
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'ticker-assets' },
            _react2.default.createElement(
              'div',
              { styleName: 'ticker-assets-figure' },
              _format2.default.perc(po_all_weight)
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'ticker-assets-label' },
              '\xA0of portfolio'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'score-wrapper' },
          _react2.default.createElement(_components.Grade, { grade: grade_deforestation })
        )
      );
    }
  }]);
  return FamilyFundListItem;
}(_react.Component)) || _class4);

/**
 * <FamilyFundListItemTickerLinks 
 *   shareclasses
 * />
 * 
 * Displays a list of tickers, linked to those shareclass profiles, for a fund
 * in the fund list. Maps a list of shareclasses to a list of URLs and
 * tickers. Maps the list of URLs and tickers to a list of Links.
 * 
 */

var FamilyFundListItemTickerLinks = (_dec5 = (0, _reactCssModules2.default)(Styles, { allowMultiple: true }), _dec5(_class5 = function (_Component5) {
  (0, _inherits3.default)(FamilyFundListItemTickerLinks, _Component5);

  function FamilyFundListItemTickerLinks(props) {
    (0, _classCallCheck3.default)(this, FamilyFundListItemTickerLinks);

    var _this5 = (0, _possibleConstructorReturn3.default)(this, (FamilyFundListItemTickerLinks.__proto__ || (0, _getPrototypeOf2.default)(FamilyFundListItemTickerLinks)).call(this, props));

    _this5.state = {
      shareclasses: props.shareclasses || null
    };
    return _this5;
  }

  (0, _createClass3.default)(FamilyFundListItemTickerLinks, [{
    key: 'render',
    value: function render() {
      var shareclasses = this.state.shareclasses;

      if (!shareclasses) {
        return null;
      }

      var tickerUrls = shareclasses.map(function (e, i) {
        var tckr = e.ticker || 'N/A';
        var safeTicker = e.ticker || 'N';
        var url = _config2.default.routes.fund + '/' + _format2.default.sanitize(e.fund_legal_name) + '/' + safeTicker + '/' + _config2.default.profilePath + '/' + e.fund_id + '/' + e.investment_vehicle_id;

        return {
          ticker: tckr,
          name: e.name,
          url: url
        };
      });

      if (tickerUrls.length === 1 && tickerUrls[0].ticker === 'N/A') {
        var e = tickerUrls[0];
        return _react2.default.createElement(
          'div',
          { styleName: 'ticker-links' },
          _react2.default.createElement(
            _components.Link,
            { to: e.url, title: e.name },
            _react2.default.createElement(
              'span',
              { styleName: 'ticker' },
              'See results',
              _react2.default.createElement(_components.LinkIcon, null)
            )
          )
        );
      }

      return _react2.default.createElement(
        'div',
        { styleName: 'ticker-links' },
        tickerUrls.map(function (e, i) {
          return _react2.default.createElement(
            _components.Link,
            {
              key: 'holding-link-' + i,
              to: e.url,
              title: e.name
            },
            e.ticker === 'N/A' ? _react2.default.createElement(
              'span',
              { styleName: 'ticker' },
              e.name
            ) : _react2.default.createElement(
              'span',
              { styleName: 'ticker' },
              e.ticker
            )
          );
        })
      );
    }
  }]);
  return FamilyFundListItemTickerLinks;
}(_react.Component)) || _class5);
var Family = (_dec6 = (0, _reactRedux.connect)(function (state) {
  return {
    result: state.familyShareClass.result,
    searching: state.familyShareClass.loading,
    searched: state.familyShareClass.loaded,
    error: state.familyShareClass.error
  };
}, searchActions), _dec7 = (0, _reactCssModules2.default)(Styles, { allowMultiple: true }), _dec6(_class6 = _dec7(_class6 = (_temp = _class7 = function (_Component6) {
  (0, _inherits3.default)(Family, _Component6);

  function Family(props) {
    (0, _classCallCheck3.default)(this, Family);

    var _this6 = (0, _possibleConstructorReturn3.default)(this, (Family.__proto__ || (0, _getPrototypeOf2.default)(Family)).call(this, props));

    _this6.getMoreFunds = function () {
      _this6.familyShareClasses(_this6.state.family, _this6.state.page + 1);
    };

    _this6.familyShareClasses = function (family, page) {
      page = page || _this6.state.page;
      _this6.setState({ page: page });
      _this6.props.familyShareClasses(family, page);
    };

    _this6.configFundFamily = function () {
      var ff = _config2.default.familyFunds;
      return ff.find(function (family) {
        return family.fund_family_name === _this6.state.family;
      });
    };

    _this6.configEngagementFamily = function () {
      var ef = _config2.default.engagementFunds;
      return ef.find(function (family) {
        return family.name === _this6.state.family;
      });
    };

    _this6.renderEngagement = function () {
      var engagementFamily = _this6.configEngagementFamily();
      if (!engagementFamily) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { styleName: 'engagement-description' },
        _react2.default.createElement(
          'p',
          null,
          'Some sustainability-mandated funds actively engage the companies they own. Indeed, efforts by sustainability-focused investors whose funds are found on this site have been crucial to driving positive change in deforestation-risk sectors like palm oil. A number of asset managers are ',
          _react2.default.createElement(
            'strong',
            null,
            'known sustainability engagers'
          ),
          ', and have taken actions such as filing \xA0',
          _react2.default.createElement(
            _components.Link,
            {
              xstrong: true,
              to: _config2.default.links.aysvote,
              title: 'Vote Your Shares | As You Sow'
            },
            'shareholder resolutions'
          ),
          '\xA0 asking for policy changes. Those asset managers deserve special acknowledgement - often, they\u2019re using their investments to make sure they have a voice at the table to call for real improvements in company behavior. We used \xA0',
          _react2.default.createElement(
            _components.Link,
            {
              xstrong: true,
              to: _config2.default.links.ceres,
              title: 'Ceres Shareholder Resolutions Database'
            },
            'data collected by Ceres'
          ),
          '\xA0 to identify asset managers that have filed shareholder resolutions on deforestation, climate change, or similar environmental issues. If a fund has investments in companies we screen for, but the asset manager is a known filer of deforestation or environmental-related shareholder resolutions, we assign a special engagement score.'
        ),
        /* if there is a list of companies filed at */
        engagementFamily.filedAt ? _react2.default.createElement(
          'p',
          null,
          engagementFamily.name,
          ' has filed deforestation or other climate-change related shareholder resolutions at\xA0',
          _react2.default.createElement(
            'strong',
            null,
            engagementFamily.filedAt
          ),
          '\xA0',
          _react2.default.createElement(
            _components.Link,
            {
              xstrong: true,
              to: _config2.default.links.ceres,
              title: 'Ceres Shareholder Resolutions Database'
            },
            'See the resolutions',
            _react2.default.createElement(_components.LinkIcon, null)
          )
        ) : null,
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            _components.Link,
            {
              xstrong: true,
              to: _config2.default.routes.faq + '#7',
              title: 'Where does the “Deforestation Grade" come from that I ' + 'see when I search a fund? | FAQ | Deforestation Free  ' + 'Funds'
            },
            'Read more about our deforestation grades.'
          )
        ),
        /* if there is an engagment family statement */
        engagementFamily.statement ? _react2.default.createElement(
          'div',
          { styleName: 'engagement-statement' },
          _react2.default.createElement(
            'div',
            { styleName: 'engagement-statement-title' },
            engagementFamily.name,
            ' submitted a statement describing their engagement efforts:'
          ),
          _react2.default.createElement(
            'blockquote',
            { styleName: 'engagement-statement-quote' },
            engagementFamily.statement
          )
        ) : null
      );
    };

    _this6.renderBox = function () {
      var fundFamily = _this6.configFundFamily();
      if (!fundFamily) {
        return null;
      }
      var name = fundFamily.fund_family_name;
      var familiesWithPetitions = (0, _keys2.default)(_config2.default.fundFamilyPetitions.data);
      var hasPetition = familiesWithPetitions.indexOf(name) >= 0;
      var entry = hasPetition ? _config2.default.fundFamilyPetitions.data[name] : null;
      var petitionLink = entry ? entry[0] : null;
      var petitionText = entry ? entry[1] : null;
      var defaultCopy = 'Major fund managers invest millions into ' + 'agricultural commodity producers and traders with business models ' + 'that destroy the rainforest, and billions more into the banks and ' + 'lenders that finance deforestation-risk producers, and the consumer ' + 'brands that use these unsustainably-produced commodities in their ' + 'products. Click below to learn more about the impact of ' + 'agricultural commodity production on global rainforests.';
      var buttonText = petitionLink ? 'Sign the petition' : 'Learn more';

      return _react2.default.createElement(
        'div',
        { styleName: 'company-snapshot' },
        _react2.default.createElement(
          'div',
          { styleName: 'company-intro' },
          petitionText || defaultCopy
        ),
        _react2.default.createElement(
          _components.Link,
          {
            title: 'Sign the petition to ask ' + name + 'for a No Deforestation Policy',
            log: _analytics2.default.eventToFamilyTakeAction(name),
            to: petitionLink || _config2.default.routes.faq,
            targetBlank: true
          },
          _react2.default.createElement(
            'div',
            { styleName: 'company-wrapper' },
            _react2.default.createElement(
              'span',
              { styleName: 'company' },
              buttonText,
              _react2.default.createElement(_components.LinkIcon, null)
            )
          )
        )
      );
    };

    _this6.renderFamily = function () {
      function getPerc(asset, totalAsset) {
        asset = _convert2.default.int(asset);
        totalAsset = _convert2.default.int(totalAsset);
        if (totalAsset === 0) {
          return 0;
        }
        // return Math.round( asset/ totalAsset * 100 ) / 100
        return parseFloat((asset / totalAsset * 100).toFixed(2));
      }

      // is this a fund family 
      var fundFamily = _this6.configFundFamily();
      if (!fundFamily) {
        return null;
      }

      /*  We currently have five asset managers with factsheets */
      var familiesWithFactSheets = ['Vanguard', 'BlackRock/iShares', 'Fidelity Investments', 'SPDR State Street Global Advisors', 'TIAA Investments/Nuveen'];
      var name = fundFamily.fund_family_name;
      var hasFactSheet = familiesWithFactSheets.indexOf(name) >= 0;

      var efna = fundFamily.equity_fund_net_assets;
      var producerPerc = getPerc(fundFamily.df_producer_asset_sum, efna);
      var bankPerc = getPerc(fundFamily.df_financier_asset_sum, efna);
      var consumerPerc = getPerc(fundFamily.df_consumer_asset_sum, efna);
      var dffPerc = getPerc(fundFamily.df_all_asset_sum, efna);

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_components.Chart, {
          renderBox: (0, _reactCssModules2.default)(_this6.renderBox, Styles),
          currency: 'US Dollar',
          invested: _convert2.default.int(fundFamily.df_all_asset_sum),
          bankPerc: bankPerc,
          consumerPerc: consumerPerc,
          producerPerc: producerPerc,
          dffPerc: dffPerc,
          famType: true
        }),
        _react2.default.createElement(_components.FlaggedFund, {
          isFamily: true,
          totalFunds: _convert2.default.int(fundFamily.num_equity_funds),
          count: _convert2.default.int(fundFamily.df_all_count_sum),
          weight: _convert2.default.float(fundFamily.df_all_weight_total)
        }),
        _react2.default.createElement(
          'div',
          { styleName: 'chart-content-hl-wrap' },
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-info-circle', nospace: true }),
            '\xA0 This data covers open-end mutual funds and exchange-traded funds domiciled in the U.S. with at least 50% of assets invested in stocks. It excludes bond funds, target date funds, and other investment vehicles like closed-end funds, collective trusts, and funds domiciled outside the U.S. ',
            _react2.default.createElement(
              'b',
              null,
              'This asset manager may have additional deforestation-risk investments in those excluded funds.'
            )
          )
        ),
        hasFactSheet ? _react2.default.createElement(_components.FamilyFactSheet, { fam: fundFamily }) : null
      );
    };

    _this6.state = {
      page: 1,
      family: props.location.query.q || '',
      searchQuery: '',
      lastResult: null,
      funds: []
    };
    return _this6;
  }

  (0, _createClass3.default)(Family, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
      this.familyShareClasses(this.state.family, 1);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      var q = props.location.query.q || '';
      if (q !== this.state.family) {
        this.familyShareClasses(q, 1);
        window.scroll(0, 0);
        this.setState({
          page: 1,
          family: q,
          searchQuery: '',
          lastResult: null,
          funds: []
        });
      } else if (props.result && this.state.lastResult !== props.result) {
        this.setState({
          lastResult: props.result,
          funds: this.state.funds.concat(props.result)
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.location.query.q) {
        return _react2.default.createElement(
          'div',
          { styleName: 'main-grid' },
          _react2.default.createElement(_components.FamilyGrid, { fullGrid: true })
        );
      }
      if (!(this.state.page !== 1 || !this.props.searching)) {
        return _react2.default.createElement(
          'div',
          { styleName: 'main' },
          _react2.default.createElement(_reactLoader2.default, { options: { scale: 0.70, top: '2.0rem' }, loaded: false })
        );
      }

      // redirect for SEO
      if (this.props.location.query.q.toUpperCase() === 'BLACKROCK' || this.props.location.query.q.toUpperCase() === 'ISHARES') {
        this.context.router.push(_config2.default.routes.families + '?q=BlackRock%2FiShares');
      }

      var funds = this.state.funds;


      var fundFamily = this.configFundFamily();

      var fileName = _format2.default.imgPath(this.state.family);
      var hasLogo = false;
      var companyLogo = null;
      try {
        companyLogo = require('../../../static/images/fam/' + fileName + '.png');
        hasLogo = true;
      } catch (e) {
        console.log('');
      }

      var hasMore = this.state.lastResult && this.state.lastResult.length === _config2.default.queryMaxFunds;

      return _react2.default.createElement(
        'div',
        { styleName: 'main' },
        _container2.default.helmet(this.state.family),
        _react2.default.createElement(
          _reactLoader2.default,
          {
            options: { scale: 0.70, top: '2.0rem' },
            loaded: this.state.page !== 1 || !this.props.searching
          },
          _react2.default.createElement(
            'div',
            { styleName: 'name-wrap-background' },
            _react2.default.createElement(
              _components.ContainerDivs,
              null,
              _react2.default.createElement(
                'div',
                { styleName: 'name-wrap' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'name' },
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'div',
                      { styleName: fundFamily ? 'name-tag-big' : 'name-tag' },
                      fundFamily ? 'Major fund manager' : 'Fund manager'
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'name-logo-lbl' },
                      fundFamily ? fundFamily.label : this.state.family
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  null,
                  hasLogo ? _react2.default.createElement('img', {
                    styleName: 'name-logo-img',
                    src: companyLogo,
                    alt: fundFamily ? fundFamily.label : this.state.family
                  }) : null
                )
              )
            )
          ),
          _react2.default.createElement(
            _components.ContainerDivs,
            null,
            this.renderEngagement(),
            this.renderFamily(),
            _react2.default.createElement('br', null),
            _react2.default.createElement('br', null),
            _react2.default.createElement(FamilySummarySentence, { fundFamily: fundFamily }),
            _react2.default.createElement(
              'div',
              { styleName: 'holdings-inner' },
              _react2.default.createElement(
                'div',
                { styleName: 'rating-label' },
                _react2.default.createElement('div', { styleName: 'rating-label-line' }),
                _react2.default.createElement(
                  'div',
                  { styleName: 'rating-label-info' },
                  'Deforestation grade'
                )
              ),
              _react2.default.createElement(FamilyFundList, { fundList: funds })
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'more-funds-wrapper' },
            _react2.default.createElement(_reactLoader2.default, {
              options: { scale: 0.70, top: '0' },
              loaded: !this.props.searching
            }),
            _react2.default.createElement(
              'div',
              { styleName: 'more-funds' },
              _react2.default.createElement(
                'div',
                {
                  onClick: hasMore ? this.getMoreFunds : null,
                  styleName: hasMore ? 'more-funds-button' : 'no-more-funds-button'
                },
                hasMore ? 'Get more funds' : 'No more funds',
                _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-plus-circle' })
              ),
              !hasMore ? _react2.default.createElement(
                'div',
                { styleName: 'no-more-funds-info' },
                'Looking for your favorite fund and can\'t find it? Sorry, but we don\'t have everything in our database.'
              ) : null
            )
          ),
          _react2.default.createElement(FamilyBanner, { fundFamily: fundFamily }),
          _react2.default.createElement(
            _components.ContainerDivs,
            null,
            _react2.default.createElement(_components.AboutBanner, null)
          )
        )
      );
    }
  }]);
  return Family;
}(_react.Component), _class7.propTypes = {
  searching: _react.PropTypes.bool,
  searched: _react.PropTypes.bool,
  error: _react.PropTypes.object,
  result: _react.PropTypes.array
}, _temp)) || _class6) || _class6);
exports.default = Family;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Family/Family.js
// module id = 1332
// module chunks = 0